<template>
  <v-card outlined>
    <v-row v-if="newItem" no-gutters align="center">
      <v-col cols="1">
        <v-row justify="center">
          <v-icon>add_circle_outline</v-icon>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-text-field
          class="mr-3"
          v-model="newItem.label"
          v-on:change="createItem()"
          placeholder="Bezeichnung"
        ></v-text-field>
      </v-col>
      <v-col cols="7"></v-col>
      <v-col cols="1"></v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "MeasureListNewItem",
  props: {
    newItem: Object,
  },
  methods: {
    createItem() {
      this.$emit("create-item", this.newItem);
    },
  },
};
</script>

<style scoped></style>
